import React, {Fragment, useEffect, useState} from "react";
import "./style.scss";

import TierHeader from "../../components/FundingEvaluation/Plans/TierHeader";
import Tier from "../../components/FundingEvaluation/Plans/Tier";
import PlanFooter from "../../components/FundingEvaluation/Plans/PlanFooter";
import LoaderOverlay from "../../reusableComponents/Loader";
import {useDispatch, useSelector} from "react-redux";
import ErrorModal from "../../reusableComponents/ErrorModal";
import customStyles from "../../customstyle/customstyle";
import Select from "react-select";
import Tabination from "../../reusableComponents/Tabination";
import {TOGGLE_Brand} from "../../store/reducers/brandSlice";
import {useNavigate} from "react-router-dom";

function Plans({plans, activeTab, tabItems, setActiveTab}) {
  const [activeTier, setActiveTier] = useState(null);

  const plansRedux = useSelector((state) => state?.account?.plans);
  const userCountry = useSelector((state) => state?.user?.country);

  const [errorModalOpen, setErrorModalOpen] = useState(plansRedux.error);
  const [isLoading, setIsLoading] = useState(plansRedux.loading);

  const tier = plans;
  const challenges = plans;

  plans?.challenges?.forEach((item) => challenges?.push(item?.name));

  //
  challenges?.forEach((name) => {
    const challenge = plans?.challenges?.find((item) => item?.name === name);
    if (challenge) {
      tier.push(challenge);
    }
  });
  const planOptions = tabItems?.map((plan) => {
    let cleanName = plan?.name
      // Remove 'EE Challenge' at the end
      ?.replace(/EE Challenge\s*$/i, "")
      // Remove 'Challenge' at the end (if not already removed)
      ?.replace(/Challenge\s*$/i, "")
      // Remove 'Account' at the end
      ?.replace(/Account\s*$/i, "")
      ?.replace(/\s+/g, " ") // collapse multiple spaces
      ?.trim();
    return {
      name: <span style={{textTransform: "capitalize "}}>{cleanName}</span>,
      content: plan?.content,
    };
  });
  console.log(tabItems, planOptions, "tabItems");

  useEffect(() => {
    setIsLoading(plansRedux.loading);
    setErrorModalOpen(plansRedux.error);
  }, [plansRedux]);
  const [footerValue, setFooterValue] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

  // Determine if the plan is a swift plan
  // const isSwift = plans?.name?.toLowerCase().includes("swift") || challenges[0]?.name?.toLowerCase().includes("swift");
  const isSwift = false;

  // Determine trading platforms based on user country and swift plan
  let tradingPlatform = [];
  if (userCountry === "Poland") {
    tradingPlatform = [{value: "mt5", label: "MT5"}];
  } else if (userCountry === "Malaysia") {
    tradingPlatform = isSwift
      ? [{value: "mt5", label: "MT5"}]
      : [
          {value: "mt5", label: "MT5"},
          {value: "matchtrade", label: "Match Trader"},
        ];
  } else {
    tradingPlatform = isSwift
      ? [{value: "mt5", label: "MT5"}]
      : [
          {value: "mt5", label: "MT5"},
          {value: "matchtrade", label: "Match Trader"},
        ];
  }
  const [broker, setBroker] = useState(tradingPlatform[0]);
  useEffect(() => {
    if (userCountry === "Poland") {
      setBroker({value: "mt5", label: "MT5"});
    } else {
      challenges[0]?.id === 13 ? setBroker({value: "matchtrade", label: "Match Trader"}) : setBroker(tradingPlatform[0]);
    }
  }, [challenges, userCountry]);

  const brandTabItems = [
    {value: "equity_edge", name: "Equity Edge"},
    // { value: "futures_edge", name: "Futures Edge" },
    {value: "crypto_edge", name: "Crypto Edge"},
  ];

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleBrandSelector = (value) => {
    dispatch(TOGGLE_Brand(value)); // Single dispatch call
    setTimeout(() => {
      if (window.location.pathname.includes("funding-evaluation") && window.location.pathname.includes("payments")) {
        navigate("/");
      } else {
        // Consider avoiding reload; update state
        window.location.reload();
      }
    }, 500);
  };

  return (
    <>
      {isLoading && <LoaderOverlay />}
      <div
        className="plans-container"
        // style={{marginTop: "100px"}}
      >
        {errorModalOpen && (
          <ErrorModal
            desc={plansRedux.message}
            setModalOpen={setErrorModalOpen}
            btnText="Cancel"
          />
        )}
        {challenges?.length !== 0 ? (
          <>
            <div className="plans_header">
              <div className="brand_tabs_wrapper">
                {brandTabItems.map((item) => (
                  <div
                    key={item.value}
                    className={`brand_tab ${selectedBrand?.brand === item.value ? "activeBrand" : ""}`}
                    onClick={() => handleBrandSelector(item.value)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
              <div className="rightSideWrapper">
                <Tabination
                  variant={7}
                  tabItems={planOptions}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
                <div className="choose_trading_platform new_broker">
                  {/* <span>Choose Your Trading Platform</span> */}
                  {/* {userCountry !== "United States" && (
                  <div>
                    <Select
                      isSearchable={false}
                      value={tradingPlatform.find((item) => item.value === broker.value)}
                      options={tradingPlatform}
                      styles={customStyles}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      onChange={(selectedOption) => {
                        setBroker(selectedOption);
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />



                  </div>

                )} */}
                  {selectedBrand?.brand === "equity_edge" && (
                    <div className="choose_trading_platform new_broker">
                      {userCountry !== "United States" && (
                        <div className="pills-container">
                          {tradingPlatform?.map((platform) => (
                            <div
                              key={platform.value}
                              className={`pill ${broker.value === platform.value ? "active" : ""}`}
                              onClick={() => setBroker(platform)}
                            >
                              {platform.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="plans-subcontainer">
              {/* <TierHeader tier={tier} /> */}
              <div className="plans-plan-container">
                {challenges?.reverse()?.map((item, index) => (
                  <Fragment key={index}>
                    <Tier
                      broker={broker.value}
                      tiers={item}
                      activeTier={activeTier}
                      setActiveTier={setActiveTier}
                      setFooterValue={setFooterValue}
                    />
                  </Fragment>
                ))}
              </div>
            </div>
            {/* <PlanFooter tier={footerValue} /> */}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default Plans;
